import { render, staticRenderFns } from "./AddServiceCenter.vue?vue&type=template&id=0529583b&scoped=true"
import script from "./AddServiceCenter.vue?vue&type=script&lang=js"
export * from "./AddServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./AddServiceCenter.vue?vue&type=style&index=0&id=0529583b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529583b",
  null
  
)

export default component.exports